<template>
  <div>
    <Breadcrumbs
      :paths="[$route.path]"
    ></Breadcrumbs>
    <v-toolbar>
      <v-toolbar-title>
        {{ $t("message.job.title") }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ma-2"  :disabled="!refreshable" @click="get_data(get_prefix() + module, get_id())">
              mdi-refresh
            </v-icon>
          </template>
          <span>{{ $t("message.common.refresh") }}</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>
    <v-card class="d-flex justify-center mt-1 pl-4">
      <GeneralSelect
        ref="general_select"
        :mode="mode"
        :label="$t('message.common.target')"
        layer_type="layer"
        :target_layer="['user']"
        :target="target"
        v-on:update_target="target = $event; get_data(get_prefix() + module, get_id())"
        v-on:clear_target="reset_target(); data = []"
      >
      </GeneralSelect>
    </v-card>
    <v-card class="d-flex justify-center mt-1">
      <v-card flat class="pa-2">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          clearable
          :label="$t('message.common.jid')"
          v-model="search_jid"
        >
        </v-text-field>
      </v-card>
      <v-card flat class="pa-2">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          clearable
          :label="$t('message.common.title')"
          v-model="search_job"
        >
        </v-text-field>
      </v-card>
      <v-card flat class="pa-2">
        <v-select
          ref="job_type"
          :label="$t('message.job.job_type')"
          :items="job_types"
          item-text="label"
          item-value="value"
          v-model="search_job_type"
          hide-details
          multiple
          @change="$refs.job_type && $refs.job_type.setMenuIndex(-1)"
        >
          <template v-slot:prepend-item>
            <v-list-item
              ripple
              @mousedown.prevent
              @click="select_all_toggle"
            >
              <v-list-item-action>
                <v-icon :color="search_job_type.length > 0 ? 'primary' : ''">
                  {{ select_all_icon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("message.common.select_all") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.label }}</span>
            </v-chip>
            <span
              v-if="index === 1"
              class="grey--text text-caption"
            >
              (+{{ search_job_type.length - 1 }}{{ $t("message.common.others") }})
            </span>
          </template>
        </v-select>
      </v-card>
      <v-card flat class="pa-2">
        <v-select
          :label="$t('message.common.status')"
          :items="statuses"
          item-text="label"
          item-value="value"
          v-model="search_status"
          hide-details
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip
              :color="status_color[item.value]"
              outlined
            >
              {{ item.label }}
            </v-chip>
          </template>
        </v-select>
      </v-card>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="data"
      :sort-by="['start_time']"
      :sort-desc="[true]"
      must-sort
      class="job-table elevation-1 mt-1"
      @click:row="$vuetify.breakpoint.xs ? '' : $router.push('/' + get_prefix() + 'job/' + $event.jid + get_referer(module));"
      :footer-props="{
        'items-per-page-options': [10, 100, 200, 500]
      }"
    >
      <template v-slot:item.jid="{ item }">
        {{ item.jid }}
      </template>
      <template v-slot:item.title="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ item.title }}
            </span>
          </template>
          <span>{{ item.title }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.type="{ item }">
        {{ $t('message.job.job_type_' + item.type) }}
      </template>
      <template v-slot:item.status="{ item }">
        <span :class="status_color[item.status]">{{ $t('message.job.status_' + item.status) }}</span>
      </template>
      <!--<template v-slot:item.progress="{ item }">
        <template v-if="['processing', 'complete'].indexOf(item.status) >= 0">
          {{ Math.round(10 * item.progress) / 10 }}%
          <v-progress-linear
            :value="item.progress"
          ></v-progress-linear>
        </template>
        <template v-else>
          -
        </template>
      </template>
      <template v-slot:item.wait_time="{ item }">
        <template v-if="item.status === 'processing'">
          {{ show_second(item.wait_time) }}
        </template>
        <template v-else>
          -
        </template>
      </template>-->
      <template v-slot:item.start_time="{ item }">
        {{ $d(1000 * item.start_time, 'long', $store.getters.langs[$i18n.locale].locale) }}
      </template>
      <template v-slot:item.operation="{ item }">
        <template v-if="item.status === 'finished'
          && item.output !== null
          && item.output.length > 0">
          <v-menu
            offset-x
            left
            min-width="600px"
            max-width="600px"
          >
            <template v-slot:activator="{ on: onMenu }">
              <v-tooltip top>
                <template v-slot:activator="{ on: onTooltip }">
                  <v-icon
                    class="ma-2"
                    v-on="{ ...onMenu, ...onTooltip }"
                    @click.stop
                  >
                    mdi-file-check
                  </v-icon>
                </template>
                <span>{{ $t("message.job.check_result") }}</span>
              </v-tooltip>
            </template>

            <v-list class="pa-3">
              <template v-for="output in item.output">
                <IdName
                  :key="output.id[0]"
                  :mode="mode"
                  :type="output.type"
                  :ids="[output.id[0]]"
                  :nav_path="get_referer(module, 'nav_path')"
                  :remarks="['estimate', 'similarity'].indexOf(item.type) >= 0 ? [item.type] : null"
                ></IdName>
              </template>
            </v-list>
          </v-menu>
        </template>
        <!--<template v-if="item.status === 'processing'">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click.stop="cancel_job(item.jid);">
                mdi-cancel
              </v-icon>
            </template>
            <span>{{ $t("message.common.cancel") }}</span>
          </v-tooltip>
        </template>-->
        <template v-if="['finished', 'cancelled', 'failed'].indexOf(item.status) >= 0 && deletable(item)">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click.stop="confirm_delete_data(get_prefix() + 'job', [item.jid], get_id())">
                mdi-delete
              </v-icon>
            </template>
            <span>{{ $t("message.common.delete") }}</span>
          </v-tooltip>
        </template>
      </template>
      <template v-if="$vuetify.breakpoint.xs" v-slot:item.action="{ item }">
        <v-btn color="primary" class="mb-2" @click="$router.push('/' + get_prefix() + 'job/' + item.jid + get_referer(module))">
          {{ $t("message.common.show_details") }}
        </v-btn>
      </template>
    </v-data-table>
    <p class="text-right pt-3">
      <v-btn to="/">
        {{ $t("message.common.return_home") }}
      </v-btn>
    </p>
    <Confirm
      ref="delete_confirm"
      :message="$t('message.common.delete_confirm')"
      :positive="$t('message.common.yes')"
      :negative="$t('message.common.no')"
    >
    </Confirm>
    <v-overlay
      :absolute="true"
      :value="progress_overlay"
    >
      <v-progress-circular
        :value="progress"
      >
        {{ progress }}
      </v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Breadcrumbs from '../components/Breadcrumbs';
import GeneralSelect from '../components/GeneralSelect';
import IdName from '../components/IdName';
import Confirm from '../components/Confirm';
import { res_list } from "../js/res_list";
import { http_error } from "../js/http_error";

export default {
  name: 'job',
  components: {
    Breadcrumbs,
    GeneralSelect,
    IdName,
    Confirm
  },
  mixins: [res_list, http_error],
  props: {
    mode: String
  },
  data: function(){
    return {
      module_id: "25",
      module: "job",
      nav_path: null,
      data: [],
      target: {
        layer: "",
        gid: "",
        uid: ""
      },
      progress: 0,
      progress_overlay: false,
      search_jid: "",
      search_job: "",
      search_job_type: [],
      job_types_all: [
        {
          "label": "translate",
          "value": "translate",
          "invalid_domains": [],
          "invalid_roles": []
        },
        {
          "label": "estimate",
          "value": "estimate",
          "invalid_domains": [],
          "invalid_roles": []
        },
        {
          "label": "train",
          "value": "train",
          "invalid_domains": ['the-reading'],
          "invalid_roles": []
        },
        {
          "label": "corpus_import",
          "value": "corpus_import",
          "invalid_domains": ['the-reading'],
          "invalid_roles": []
        },
        {
          "label": "term_import",
          "value": "term_import",
          "invalid_domains": ['the-reading'],
          "invalid_roles": []
        },
        {
          "label": "similarity",
          "value": "similarity",
          "invalid_domains": ['the-reading'],
          "invalid_roles": []
        },
        {
          "label": "change_name",
          "value": "change_name",
          "invalid_domains": [],
          "invalid_roles": ["user", "group_manager"]
        },
        {
          "label": "change_gid",
          "value": "change_gid",
          "invalid_domains": [],
          "invalid_roles": ["user", "group_manager"]
        },
        {
          "label": "modify",
          "value": "modify",
          "invalid_domains": ['the-reading'],
          "invalid_roles": []
        },
        {
          "label": "batch_user",
          "value": "batch_user",
          "invalid_domains": [],
          "invalid_roles": ["user"]
        },
        {
          "label": "list_user",
          "value": "list_user",
          "invalid_domains": [],
          "invalid_roles": ["user"]
        }
      ],
      search_status: [],
      statuses_all: [
        {
          "label": "pending",
          "value": "pending"
        },
        {
          "label": "finished",
          "value": "finished"
        },
        {
          "label": "processing",
          "value": "processing"
        },
        {
          "label": "failed",
          "value": "failed"
        },
      ],
      status_color: {
        "pending": "",
        "finished": "lime--text",
        "processing": "",
        "failed": "red--text",
        "cancelled": "grey--text"
      },
    }
  },
  computed: {
    headers: function() {
      let table_headers = [
        {
          text: this.$i18n.t("message.common.jid"),
          value: 'jid',
          filter: value => {
            if(this.search_jid === "" || this.search_jid === null){
              return true;
            }
            return value.indexOf(this.search_jid) !== -1;
          }
        },
        {
          text: this.$i18n.t("message.common.title"),
          value: 'title',
          filter: value => {
            if(this.search_job === "" || this.search_job === null){
              return true;
            }
            return value.indexOf(this.search_job) !== -1;
          },
          cellClass: 'title-column'
        },
        {
          text: this.$i18n.t("message.job.job_type"),
          value: 'type',
          filter: value => {
            return this.search_job_type.indexOf(value) >= 0;
          }
        },
        {
          text: this.$i18n.t("message.common.status"),
          value: 'status',
          filter: value => {
            return this.search_status.indexOf(value) >= 0;
          }
        },
        /*{ text: this.$i18n.t("message.common.progress") + "(%)", value: 'progress' },
        { text: this.$i18n.t("message.job.wait_time"), value: 'wait_time' },*/
        { text: this.$i18n.t("message.job.start_time"), value: 'start_time' },
        {
          text: this.$i18n.t("message.common.operation"),
          value: 'operation',
          sortable: false
        }
      ];
      if(this.$vuetify.breakpoint.xs){
        table_headers.push({
        text: '',
        value: 'action',
        sortable: false
        });
      }
      return table_headers;
    },
    job_types: function(){
      var domain = "";
      var role = "";
      if(this.$store.getters.user){
        domain = this.$store.getters.user.domain;
        role = this.$store.getters.user.role;
      }
      var job_types = [];
      for(var job_type of this.job_types_all){
        if(job_type.invalid_domains.indexOf(domain) >= 0
          || (job_type.invalid_roles.indexOf(role) >= 0 && this.mode === "user")){
          continue;
        }
        job_types.push({
          label: this.$i18n.t('message.job.job_type_' + job_type.label),
          value: job_type.value
        });
      }
      return job_types;
    },
    statuses: function(){
      var statuses = [];
      for(var status of this.statuses_all){
        statuses.push({
          label: this.$i18n.t('message.job.status_' + status.label),
          value: status.value
        });
      }
      return statuses;
    },
    select_all_icon: function() {
      if(this.job_types.length === this.search_job_type.length){
        return 'mdi-close-box';
      }else if(this.search_job_type.length === 0){
        return 'mdi-checkbox-blank-outline';
      }else{
        return 'mdi-minus-box';
      }
    },
  },
  mounted() {
    var job_types_value = this.job_types.map(v => v.value);
    if(this.$route.query.job_type
      && this.$route.query.job_type !== "all"){
      var job_type = [];
      for(var jt of this.$route.query.job_type.split(",")){
        if(job_types_value.indexOf(jt) !== -1){
          job_type.push(jt);
        }
      }
      this.search_job_type = job_type;
    }else{
      this.search_job_type = job_types_value;
    }
    var statuses_value = this.statuses.map(v => v.value);
    if(this.$route.query.status
      && this.$route.query.status !== "all"){
      var status = [];
      for(var s of this.$route.query.status.split(",")){
        if(statuses_value.indexOf(s) !== -1){
          status.push(s);
        }
      }
      this.search_status = status;
    }else{
      this.search_status = this.statuses.map(x => x.value);
    }
    if(this.$route.query.search_jid){
      this.search_jid = this.$route.query.search_jid;
    }
    if(this.$route.query.search_job){
      this.search_job = this.$route.query.search_job;
    }
  },
  methods: {
    show_second: function(second){
      var hour = Math.floor(second / 3600);
      var minute = Math.floor((second % 3600) / 60);
      if(hour > 0){
        return hour + ":" + ('0' + minute).slice(-2) + ":" + ('0' + (second % 60)).slice(-2);
      }
      return ('0' + minute).slice(-2) + ":" + ('0' + (second % 60)).slice(-2)
    },
    select_all_toggle: function(){
      this.$nextTick(() => {
        if(this.job_types.length === this.search_job_type.length){
          this.search_job_type = []
        }else{
          this.search_job_type = this.job_types.map(x => x.value);
        }
      })
    },
    /*cancel_job: function(jid){
      if(!window.confirm(this.$i18n.t("message.user.delete_confirm"))){
        return;
      }
      var url = this.$store.getters.api_endpoint + "/user/" + iss + "/" + user;
      this.$http.delete(url)
        .then( response => {
          this.get_users();
        });
    }*/
  }
}
</script>
<style scoped>
.job-table >>> .title-column {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(50vw - 300px);
}
.v-tooltip__content {
  word-break: break-all;
}
</style>
